/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Winner_DescInputs */



/**
* | output |
* | --- |
* | "only the winner's deck" |
*
* @param {Og_Cfg_Winner_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_winner_desc = /** @type {((inputs?: Og_Cfg_Winner_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Winner_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("uniquement le deck du vainqueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("solo el mazo del ganador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("apenas o deck do vencedor")
	if (locale === "it") return /** @type {LocalizedString} */ ("solo il mazzo del vincitore")
	return /** @type {LocalizedString} */ ("only the winner's deck")
});